<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.common">
    <app-popup-header title="{{localService.languageContent.common.usage_limit_header}}"></app-popup-header>
    <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
        <div class="row">
            <div class="col-12">
                {{localService.languageContent.common.usage_limit}}
            </div>
        </div>
        <div *ngIf="items" class="box">
            <div class="row styled_row" *ngFor="let item of items">
                <div class="col-12">
                    <div class="en usage_limit_date">{{item.v1 | localDate}}&nbsp;</div>
                    <span class="button" (click)="localService.showSummary(item.v2, 1)"
                        [ngClass]="localService.getLanguageCode(item.v3)">{{item.v4}}</span>
                </div>
            </div>
        </div>
    </div>
</div>